module.exports = __webpack_public_path__ + "img/alarm.1ec8e5b5.gif";